import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    name: 'Name',
    status: 'Status',
    address: 'Address',
    amountSpent: 'Amount Spent',
  },
};
